import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

import {
  InputFakeLink,
  InputWithLabel,
} from "components/Input/InputFakeCustoms";
import { __formaterCant } from "components/Funciones/formaterCant";
import FormCrudCRUDContext from "context/FormCrudContex";
import { ReviewPopover } from "../ReviewPopover";
import {
  isNumberFormatable,
  isObject,
  isObjectNotEmpty,
} from "utils/type-check-utils";
import { NumericFormat } from "react-number-format";
import { Grid, GridItem, SimpleGrid } from "@chakra-ui/react";

export const renderInputWithLabel = ({
  labelText,
  optionalName = null,
  name,
  manualValue = null,
  additionalProps = {},
  PropsBox = {
    size: "100%",
  },
  activeComment = false,
  wrapInDiv = true,
  disableFormatting = false,
  labelLink = null,
  annotationInfo = {
    notations: null,
    id: null,
    data: null,
  },
}) => {
  const value =
    manualValue ||
    `${annotationInfo?.data?.[name] ?? "N/A"} ${annotationInfo?.data?.[optionalName] ?? ""
    }`;

  const commonProps = {
    ...(annotationInfo?.notations && {
      inputBgColor: annotationInfo?.notations?.getColorByFieldName(
        annotationInfo?.id,
        name
      ),
    }),
    ...(annotationInfo?.notations && {
      tooltipText: annotationInfo?.notations.getNestedPropertyValue(
        annotationInfo?.id,
        name
      ),
    }),

    value,
    labelText,
    name,
    p: 0,
    "data-name-id": labelText,
    borderRadius: "none",
    ...(labelLink && { labelLink }),
    ...(activeComment && {
      customConfig: {
        icon: (
          <ReviewPopover
            notations={annotationInfo?.notations || {}}
            id={annotationInfo?.id}
          />
        ),
        text: "Revisión",
        color: "#009bfc",
      },
    }),
    ...additionalProps,
  };
  const isFormartable =
    isNumberFormatable(manualValue) || isNumberFormatable(commonProps?.value);

  const isScientifciNotation = isNumberFormatable(manualValue)
    ? parseFloat(manualValue)
    : parseFloat(commonProps?.value);

  const { value: _, ...rest } = commonProps;
  rest.value = isScientifciNotation;

  if (!wrapInDiv) {
    if (isFormartable && !disableFormatting) {
      return (
        <NumericFormat
          allowNegative={false}
          thousandSeparator={additionalProps.thousandSeparator ?? true}
          decimalSeparator="."
          customInput={InputWithLabel}
          {...rest}
          data-item-id={annotationInfo?.id}
        />
      );
    }

    return (
      <InputWithLabel {...commonProps} data-item-id={annotationInfo?.id} />
    );
  }

  if (isFormartable && !disableFormatting) {
    return (
      <div
        {...(isObject(PropsBox) && isObjectNotEmpty(PropsBox)
          ? PropsBox
          : { className: "col-md-3" })}
      >
        <NumericFormat
          allowNegative={false}
          thousandSeparator={additionalProps.thousandSeparator ?? true}
          decimalSeparator="."
          customInput={InputWithLabel}
          {...rest}
          data-item-id={annotationInfo?.id}
        />
      </div>
    );
  }

  return (
    <div
      {...(isObject(PropsBox) && isObjectNotEmpty(PropsBox)
        ? PropsBox
        : { className: "col-md-3" })}
    >
      <InputWithLabel {...commonProps} data-item-id={annotationInfo?.id} />
    </div>
  );
};

const ViewItemsEntryForm = ({ notationsDestruct = null, data, alldata }) => {
  const location = useLocation();
  const { ExitNumber = "" } = queryString.parse(location.search);
  const [ItemsData, setItemsData] = useState([]);
  const [Status, setStatus] = useState([]);
  const { pathname } = location;
  const { dataForm } = useContext(FormCrudCRUDContext);

  useEffect(() => {
    const statusForm =
      alldata?.status_outputForm ||
      alldata?.status_entryForm ||
      data?.status_entryForm ||
      data?.status_outputForm;

    if (statusForm) {
      setStatus(statusForm);
    }

    if (data) setItemsData(data || alldata);
  }, [data, alldata]);

  const urlTemplates = {
    DESADUANAMIENTO: `/ShowCustomsClearance?Customs=${data?.form_id}`,
    "CERTIF.INT": `/ShowIntegrationBox?id=${data?.form_id}`,
    "CUADR.INT.": `/ShowIntegrationBox?id=${data?.form_id}`,
    INGRESO: `/FormShow?FormEntry=${data?.form_id}`,
    SALIDA: `/FormShowExit?ExitNumber=${data?.form_id}`,
    "INGRESO ANULADO": `/FormShow?FormEntry=${data?.form_id}`,
    "SALIDA ANULADA": `/FormShowExit?ExitNumber=${data?.form_id}`,
    "INGRESO CORREGIDO": `/FormCorrection?ShowEntry=${data?.form_id}`,
    "INGRESO CORREGIDO DEV": `/FormCorrection?ShowEntry=${data?.form_id}`,
    "SALIDA CORREGIDA": `/FormCorrectionOutput?ShowOutput=${data?.form_id}`,
    "SALIDA CORREGIDO DEV": `/FormCorrectionOutput?ShowOutput=${data?.form_id}`,
    "SALIDA CORREGIDA DEV": `/FormCorrectionOutput?ShowOutput=${data?.form_id}`,
    "CERTIF.INT CORREGIDO": `/ShowIntegrationBox?id=${data?.form_id}`,
    "CUADR.INT. CORREGIDO": `/ShowIntegrationBox?id=${data?.form_id}`,
    "DESPACHO CORREGIDO": `/DispathcCorrectionShow?Dispatch=${data?.form_id}&Action=Show`,
    DESPACHO: `/pases?numberForm=${data?.form_code}&id=${data?.form_id}&status=${data?.status}&typeO=Dispatch`,
    "DESP.INTEG.": `/ShowIntegrationBox?id=${data?.form_id}`,
  };

  const isShowForm = pathname === "/FormShow";
  const isShowExitForm = pathname === "/FormShowExit";
  const isCheckFormExit = pathname === "/CheckForm";
  const isCheckFormEntry = pathname === "/CheckFormEntry";
  const isFormExit = isShowExitForm || isCheckFormExit;
  const isFormEntry = isShowForm || isCheckFormEntry;

  // Función para obtener la URL de referencia - solución robusta y definitiva
  const getReferenceUrl = () => {
    // Buscar form_id en diferentes campos posibles
    const formId = data?.form_id;

    // Si hay un template específico para el type_form, usarlo primero
    if (data?.type_form && urlTemplates[data.type_form] && formId) {
      return urlTemplates[data.type_form];
    }
    
    // Si hay form_id, intentar construir la URL
    if (formId) {
      const reference = (data?.reference || '').toUpperCase();
      
      // Detectar tipo de referencia por el contenido o type_form
      if (data?.type_form) {
        // Si hay type_form pero no está en templates, intentar detectar
        const typeFormUpper = data.type_form.toUpperCase();
        if (typeFormUpper.includes('CERTIF') || typeFormUpper.includes('CUADR') || typeFormUpper.includes('INT')) {
          return `/ShowIntegrationBox?id=${formId}`;
        }
        if (typeFormUpper.includes('INGRESO') || typeFormUpper.includes('ENTRY')) {
          return `/FormShow?FormEntry=${formId}`;
        }
        if (typeFormUpper.includes('SALIDA') || typeFormUpper.includes('EXIT') || typeFormUpper.includes('OUTPUT')) {
          return `/FormShowExit?ExitNumber=${formId}`;
        }
        if (typeFormUpper.includes('DESADUAN') || typeFormUpper.includes('CUSTOMS')) {
          return `/ShowCustomsClearance?Customs=${formId}`;
        }
        if (typeFormUpper.includes('DESPACHO') || typeFormUpper.includes('DISPATCH')) {
          return `/pases?numberForm=${data?.form_code || data.reference || ''}&id=${formId}&status=${data?.status || ''}&typeO=Dispatch`;
        }
      }
      
      // Detectar por el contenido de la referencia
      if (reference) {
        if (reference.startsWith('C') || reference.includes('CERTIF') || reference.includes('CUADR') || reference.includes('CI-')) {
          return `/ShowIntegrationBox?id=${formId}`;
        }
        if (reference.includes('INGRESO') || reference.includes('ENTRY') || reference.includes('E-') || /^E-\d+/.test(reference)) {
          return `/FormShow?FormEntry=${formId}`;
        }
        if (reference.includes('SALIDA') || reference.includes('EXIT') || reference.includes('OUTPUT') || reference.includes('S-') || /^S-\d+/.test(reference)) {
          return `/FormShowExit?ExitNumber=${formId}`;
        }
        if (reference.includes('DESADUAN') || reference.includes('CUSTOMS') || reference.includes('DEX')) {
          return `/ShowCustomsClearance?Customs=${formId}`;
        }
        if (reference.includes('DESPACHO') || reference.includes('DISPATCH')) {
          return `/pases?numberForm=${data?.form_code || data.reference}&id=${formId}&status=${data?.status || ''}&typeO=Dispatch`;
        }
      }
      
      // Por contexto: si estamos viendo un formulario de ingreso, asumir que la referencia es un ingreso
      if (isFormEntry) {
        return `/FormShow?FormEntry=${formId}`;
      }
      // Si estamos viendo un formulario de salida, asumir que es una salida
      if (isFormExit) {
        return `/FormShowExit?ExitNumber=${formId}`;
      }
      
      // Último recurso: intentar como ingreso por defecto
      return `/FormShow?FormEntry=${formId}`;
    }
    
    // Si no hay form_id pero hay referencia, intentar extraer ID de la referencia
    // SIEMPRE intentar crear un link si hay referencia
    if (data?.reference && data.reference !== "N/A") {
      const reference = String(data.reference).trim();
      // Si la referencia es un número, usarlo como ID
      if (/^\d+$/.test(reference)) {
        if (isFormEntry) {
          return `/FormShow?FormEntry=${reference}`;
        }
        if (isFormExit) {
          return `/FormShowExit?ExitNumber=${reference}`;
        }
        // Por defecto, intentar como ingreso
        return `/FormShow?FormEntry=${reference}`;
      }
      // Si la referencia tiene formato E-XXX o S-XXX, extraer el número
      const match = reference.match(/^[ES]-(\d+)/);
      if (match) {
        const refId = match[1];
        if (reference.startsWith('E-')) {
          return `/FormShow?FormEntry=${refId}`;
        }
        if (reference.startsWith('S-')) {
          return `/FormShowExit?ExitNumber=${refId}`;
        }
      }
      // Si empieza con C, puede ser certificado de integración
      if (reference.startsWith('C') && /^\d+$/.test(reference.substring(1))) {
        return `/ShowIntegrationBox?id=${reference.substring(1)}`;
      }
      // Si contiene números, intentar extraerlos
      const numberMatch = reference.match(/\d+/);
      if (numberMatch) {
        const extractedId = numberMatch[0];
        // Intentar determinar el tipo por el contexto
        if (isFormEntry || reference.includes('INGRESO') || reference.includes('ENTRY') || reference.includes('E-')) {
          return `/FormShow?FormEntry=${extractedId}`;
        }
        if (isFormExit || reference.includes('SALIDA') || reference.includes('EXIT') || reference.includes('S-')) {
          return `/FormShowExit?ExitNumber=${extractedId}`;
        }
        // Por defecto, intentar como ingreso
        return `/FormShow?FormEntry=${extractedId}`;
      }
    }
    
    return null;
  };

  const annotationInfo = {
    notations: notationsDestruct,
    id: ItemsData?.id,
    data: ItemsData,
  };

    // Si es un servicio, solo mostrar campos específicos
  if (dataForm?.services == 1) {
    return (
      <Grid
        templateAreas={`"service-fields"`}
        gap={4}
      >
        <GridItem area={"service-fields"}>
          <Grid
            gridTemplateColumns={"repeat(auto-fit, minmax(150px, 1fr))"}
            gap={2}
          >
            {/* ID */}
            {/* {renderInputWithLabel({
              labelText: "ID",
              name: "id",
              manualValue: data?.id ?? "N/A",
              activeComment: isCheckFormExit || isCheckFormEntry,
              annotationInfo,
              PropsBox: {
                width: 100,
                size: 100,
              }
            })} */}

            {/* Item */}
            {/* {renderInputWithLabel({
              labelText: "Item",
              name: "item",
              manualValue: data?.item ?? "N/A",
              activeComment: isCheckFormExit || isCheckFormEntry,
              annotationInfo,
              PropsBox: {
                width: 100,
                size: 100,
              }
            })} */}

            {(() => {
              const referenceUrl = getReferenceUrl();
              const hasReference = data?.reference && data.reference !== "N/A";
              // Si hay referencia pero no URL, crear una URL de búsqueda genérica
              const finalUrl = referenceUrl || (hasReference && isFormEntry ? `/FormShow?FormEntry=${data.reference}` : hasReference && isFormExit ? `/FormShowExit?ExitNumber=${data.reference}` : null);
              
              return (
                <InputFakeLink
                  labelText="Referencia"
                  url={finalUrl}
                  value={data?.reference || "N/A"}
                  disableRedirect={!finalUrl}
                />
              );
            })()}

            {/* Tasa de Cambio */}
            {
              /* (isShowExitForm || isCheckFormExit) && */
              renderInputWithLabel({
                labelText: `Tasa de Cambio`,
                name: "exchange_rate",
                activeComment: isCheckFormExit || isCheckFormEntry,
                annotationInfo,
              })
            }

            {/* Cantidad por reingresar */}
            {
              alldata?.services === 1 &&
              renderInputWithLabel({
                labelText: isFormExit
                  ? `Salida de otros servicios:`
                  : isFormEntry
                    ? `Ingresos otros servicios:`
                    : "",
                name: "service",
                activeComment: isCheckFormExit || isCheckFormEntry,
                annotationInfo,
              })
            }
          </Grid>

        {/* Descripción de Producto */}
        {
          /* (isShowForm || isShowExitForm) && */
          renderInputWithLabel(
            {
              labelText: "Descripción de Producto",
              name: "product_description",
              manualValue: data?.description_product ?? data?.product_description ?? "N/A",
              activeComment: isCheckFormExit || isCheckFormEntry,
              annotationInfo,
              additionalProps: {
                as: "textarea",
              },
              PropsBox: {
                w: 100,
              },
            } /* ,
          {
            className: 'col-md-12"',
          } */
          )
        }

        {/*  <Input overflow={'hidden'} /> */}
        {
          /* (isShowExitForm || isCheckFormExit) && */
          renderInputWithLabel({
            labelText: `Descripción larga`,
            name: "form_item_description",
            manualValue:
              data?.entry_form_item_description ||
              data?.output_form_item_description ||
              data?.form_item_description ||
              "N/A",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
            additionalProps: {
              as: "textarea",
              overflow: "hidden",
              h: "auto",
            },
            PropsBox: {
              w: 100,
            },
          })
        }
        </GridItem>
      </Grid>
    );
  }

  return (
    <>
      <SimpleGrid
        columns={{ base: 1, sm: 1, md: 5 }}
        minChildWidth={{ "3sm": '200px', md: "200px" }}
        my={2}
        gap={2}
      >

        {(() => {
          const referenceUrl = getReferenceUrl();
          const hasReference = data?.reference && data.reference !== "N/A";
          // Si hay referencia pero no URL, crear una URL de búsqueda genérica
          const finalUrl = referenceUrl || (hasReference && isFormEntry ? `/FormShow?FormEntry=${data.reference}` : hasReference && isFormExit ? `/FormShowExit?ExitNumber=${data.reference}` : null);
          
          return (
            <InputFakeLink
              labelText="Referencia"
              url={finalUrl}
              value={data?.reference || "N/A"}
              disableRedirect={!finalUrl}
            />
          );
        })()}

        {/* Código producto */}
        {
          /* (Status !== "PRESENTADO" || isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Código de producto",
            name: "code_product",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
            disableFormatting: true,
          })
        }

        {/* Unidad de producto */}
        {
          /* (Status !== "PRESENTADO" || isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Unidad de producto",
            name: "product_unit",
            manualValue: `${data?.code_unit_measurement || ""} ${data?.unit_measurement || "0"
              }`,
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Factor de conversión */}
        {
          /* (Status !== "PRESENTADO" || isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Factor de conversión",
            name: "factor_conv",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }
        {/* Cantidad de producto */}
        {
          /* (Status !== "PRESENTADO" || isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Cantidad de producto",
            name: "product_quantity",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }
      </SimpleGrid>



      <SimpleGrid
        columns={{ base: 1, sm: 1, "3sm": 3, md: 6, lg: 6 }}
        minChildWidth={{ "3sm": '200px', md: "200px", lg: "150px" }}
        my={2}
        gap={2}
      >

        {/* Ítem salida temporal (abajo cuando no es de salida temporal, arriba cuando es de salida temporal) */}
        {((isShowForm || !isShowExitForm)) &&
          renderInputWithLabel({
            labelText: "Ítem salida temporal",
            name: "item_temporary_exit",
            manualValue: data?.item_temporary_exit || "",
            activeComment: false,
            // annotationInfo,
          })}

        {/* Tipo de Producto */}
        {
          /* (isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Tipo de Producto",
            name: "name_typeProduct",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Peso bruto Sdo */}
        {
          renderInputWithLabel({
            labelText: "Peso bruto Sdo",
            name: "gross_weight_sdo",
            activeComment: false,
            manualValue: data?.gross_weight_sdo || "",
            // annotationInfo,
          })
        }

        {/* Cantidad Sdo. Subpartida */}
        {
          renderInputWithLabel({
            labelText: "Cantidad Sdo. Subpartida",
            name: "amount_sdo_product",
            activeComment: false,
            manualValue: data?.amount_sdo_product || "",
          })
        }

        {/* Cantidad Sdo */}
        {
          renderInputWithLabel({
            labelText: "Cantidad Sdo.",
            name: "amount_sdo",
            activeComment: false,
            manualValue: data?.amount_sdo || "",
          })
        }

        {/* Saldo FOB */}
        {dataForm?.reentry_operation === 1
          ? ""
          : renderInputWithLabel({
            labelText: `Saldo FOB`,
            name: "fob_sdo_value",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })}

        {/* Saldo CIF */}
        {dataForm?.reentry_operation === 1
          ? ""
          : renderInputWithLabel({
            labelText: `Saldo CIF`,
            name: "cif_value_sdo",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })}
      </SimpleGrid>




      <SimpleGrid
        columns={{ sm: 1, md: 3, lg: 3 }}
        minChildWidth={{ "3sm": '200px', md: "200px", lg: "250px", xl: "320px" }}
        my={2}
        gap={2}
      >
        {/* Subpartida arancelaria */}
        {
          /* (Status !== "PRESENTADO" || isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Subpartida arancelaria",
            name: "code_subheading",
            manualValue:
              data?.code_subheading || data?.code_subheading_corrected || "N/A",
          })
        }
        {
          /* (Status !== "PRESENTADO" || isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Descripción de la subpartida",
            name: "description_subheading",
            manualValue:
              data?.description_subheading || data?.description_subheading_corrected || "N/A",
          })
        }
        {/* País origen */}
        {
          (Status !== "PRESENTADO" || isShowForm || isShowExitForm) &&
          renderInputWithLabel({
            labelText: "País origen",
            name: "name_country",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* País procedencia */}
        {
          !isCheckFormExit &&
          !ExitNumber &&
          renderInputWithLabel({
            labelText: "País procedencia",
            name: "name_country_proc",
            manualValue: `${data?.code_country_proc} ${data?.name_country_proc}`,
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* País de compra */}
        {
          /* (isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "País de compra",
            name: "name_country_purs",
            manualValue: `${data?.code_country_purs ?? "N/A"} ${data?.name_country_purs ?? ""
              }`,
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }
        {/* Peso bruto en Kg */}
        {
          /* (isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Peso bruto en Kg",
            name: "gross_weight",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }
      </SimpleGrid>

      <SimpleGrid
        columns={{ sm: 1, md: 3, lg: 3 }}
        minChildWidth={{ "3sm": '200px', md: "200px", lg: "250px", xl: "320px" }}
        my={2}
        gap={2}
      >
        {/* Peso neto Kg */}
        {
          /* (isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Peso neto en Kg",
            name: "net_weight",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Números de bultos */}
        {
          /* (isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Números de bultos",
            name: "number_packages",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Cantidad */}
        {
          /* (isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Cantidad",
            name: "quantity",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }


        {/* Unidad comercial */}
        {
          /* (isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Unidad comercial",
            name: "code_businessUnit",
            manualValue: `${data?.code_businessUnit ?? "N/A"} ${data?.name_businessUnit ?? ""
              }`,
          })
        }

        {/* Modo de transporte */}
        {
          /* (isShowForm || isShowExitForm) && */
          renderInputWithLabel({
            labelText: "Modo de transporte",
            name: "name_transportMethod",
            manualValue: `${data?.code_transportMethod ?? "N/A"} ${data?.name_transportMethod ?? ""
              }`,
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Bandera */}
        {
          /* isShowExitForm && */
          renderInputWithLabel({
            labelText: "Bandera",
            name: "name_country_flag",
            manualValue: `${data?.code_country_flag ?? "N/A"} ${data?.name_country_flag ?? ""
              }`,
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Embalaje */}
        {
          /* !isShowExitForm && */
          renderInputWithLabel({
            labelText: "Embalaje",
            name: "name_packaging",
            manualValue: `${data?.code_packaging ?? ""}  ${data?.name_packaging ?? "N/A"
              }`,
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Fletes */}
        {
          /* !isShowExitForm && */
          renderInputWithLabel({
            labelText: "Fletes",
            name: "us_freight",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Seguros */}
        {
          /* !isShowExitForm && */
          renderInputWithLabel({
            labelText: "Seguros",
            name: "us_insurance",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Otros gastos */}
        {
          /* !isShowExitForm && */
          renderInputWithLabel({
            labelText: "Otros costos y gastos",
            name: "other_us_expenses",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Valor FOB */}
        {
          /* !isShowExitForm && */
          renderInputWithLabel({
            labelText: `Valor FOB ${data?.coin ?? ""}`,
            name: "us_fob_value",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Valor CIF US$ */}
        {
          /* !isShowExitForm && */
          renderInputWithLabel({
            labelText: `Valor CIF US`,
            name: "cif_us_value",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Valor CIF US$ */}
        {
          /* !isShowExitForm && */
          renderInputWithLabel({
            labelText: `Valor CIF COP`,
            name: "cif_cop_value",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Tasa de Cambio */}
        {
          /* (isShowExitForm || isCheckFormExit) && */
          renderInputWithLabel({
            labelText: `Tasa de Cambio`,
            name: "exchange_rate",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Acuerdo Comercial */}
        {
          /* (isShowExitForm || isCheckFormExit) && */
          renderInputWithLabel({
            labelText: `Acuerdo Comercial`,
            name: "name_tradeAgreement",
            manualValue: `${data?.code_tradeAgreement ?? ""} ${data?.name_tradeAgreement ?? "N/A"
              }`,
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Puerto */}
        {
          !isShowExitForm &&
          renderInputWithLabel({
            labelText: "Puerto",
            name: "port",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Naturaleza */}
        {
          alldata?.code_operation >= 500 && alldata?.code_operation <= 599 &&
          renderInputWithLabel({
            labelText: "Naturaleza",
            name: "national_or_foreign",
            manualValue: data?.national_or_foreign || "N/A",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Factura */}
        {
          /* (isShowExitForm || isCheckFormExit) && */
          renderInputWithLabel({
            labelText: `Factura`,
            name: "invoice",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
            disableFormatting: true,
          })
        }

        {/* Marca */}
        {
          /* (isShowExitForm || isCheckFormExit) && */
          renderInputWithLabel({
            labelText: `Marca`,
            name: "brand",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Serial */}
        {
          /* (isShowExitForm || isCheckFormExit) && */
          renderInputWithLabel({
            labelText: `Serial`,
            name: "serial",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }

        {/* Cantidad por reingresar */}
        {
          alldata?.services === 1 &&
          renderInputWithLabel({
            labelText: isFormExit
              ? `Salida de otros servicios:`
              : isFormEntry
                ? `Ingresos otros servicios:`
                : "",
            name: "service",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
          })
        }
      </SimpleGrid>

      <SimpleGrid
        columns={{ sm: 1 }}
        my={2}
        gap={2}
      >

        {/* Descripción de Producto */}
        {
          /* (isShowForm || isShowExitForm) && */
          renderInputWithLabel(
            {
              labelText: "Descripción de Producto",
              name: "product_description",
              manualValue: data?.description_product ?? data?.product_description ?? "N/A",
              activeComment: isCheckFormExit || isCheckFormEntry,
              annotationInfo,
              additionalProps: {
                as: "textarea",
              },
              PropsBox: {
                w: 100,
              },
            } /* ,
          {
            className: 'col-md-12"',
          } */
          )
        }

        {/*  <Input overflow={'hidden'} /> */}
        {
          /* (isShowExitForm || isCheckFormExit) && */
          renderInputWithLabel({
            labelText: `Descripción larga`,
            name: "form_item_description",
            manualValue:
              data?.entry_form_item_description ||
              data?.output_form_item_description ||
              data?.form_item_description ||
              "N/A",
            activeComment: isCheckFormExit || isCheckFormEntry,
            annotationInfo,
            additionalProps: {
              as: "textarea",
              overflow: "hidden",
              h: "auto",
            },
            PropsBox: {
              w: 100,
            },
          })
        }
      </SimpleGrid>


      {/* Se comentan estos campos que hacen parte de ViewItemsOutputForm solamente */}
      {/* {
        (isShowExitForm || isCheckFormExit) && (
          <div className="col-md-3">
            <InputFakeLink
              labelText="Declaración de importación"
              url={`/ShowCustomsClearance?Customs=${data?.custom_clearance_id}`}
              value={data?.customs_clearance || "N/A"}
              disableRedirect={!data?.custom_clearance_id}
            />
          </div>
        )
      } */}

      {/* {
        (isShowExitForm || isCheckFormExit) &&
        renderInputWithLabel({
          labelText: "Código de operación",
          name: "operation_code",
          activeComment: isCheckFormExit || isCheckFormEntry,
          annotationInfo,
        })
      } */}

      {/* {
        (isShowExitForm || isCheckFormExit) &&
        renderInputWithLabel({
          labelText: "Operación inicial",
          name: "initial_operation",
          activeComment: isCheckFormExit || isCheckFormEntry,
          annotationInfo,
        })
      } */}

      {/* País destino */}
      {/* {
        (isShowExitForm || isCheckFormExit) &&
        renderInputWithLabel({
          labelText: "País destino",
          name: "name_country_des",
          activeComment: isCheckFormExit || isCheckFormEntry,
          annotationInfo,
        })
      }
 */}


      {/* Valor FOB Inicial US$ */}
      {/* {
        (isShowExitForm || isCheckFormExit) &&
        renderInputWithLabel({
          labelText: `Valor FOB Inicial US$`,
          name: "value_fob_unit_product",
          manualValue: data?.original_fob_value_us ?? "N/A",
          activeComment: isCheckFormExit || isCheckFormEntry,
          annotationInfo,
        })
      }
 */}
      {/* Valor a reintegrar */}
      {/* {
        (isShowExitForm || isCheckFormExit) &&
        renderInputWithLabel({
          labelText: `Valor a reintegrar`,
          name: "refund_value_us",
          activeComment: isCheckFormExit || isCheckFormEntry,
          annotationInfo,
        })
      } */}

      {/* Valor agregado US$ */}
      {/* {
        (isShowExitForm || isCheckFormExit) &&
        renderInputWithLabel({
          labelText: `Valor agregado US$`,
          name: "added_value_us",
          activeComment: isCheckFormExit || isCheckFormEntry,
          annotationInfo,
        })
      } */}



      {/* Cantidad por reingresar */}
      {/* {
        (isShowExitForm || isCheckFormExit) &&
        renderInputWithLabel({
          labelText: `Cantidad por reingresar`,
          name: "amount_refunded",
          activeComment: isCheckFormExit || isCheckFormEntry,
          annotationInfo,
        })
      } */}



      {/* Cantidad por reingresar */}
      {/*   {(isShowExitForm || isCheckFormExit) &&
        renderInputWithLabel({
          labelText: `Servicio`,
          name: "service",
          manualValue: data?.service ? __formaterCant(data?.service) : "N/A",
          activeComment: isCheckFormExit || isCheckFormEntry,
          annotationInfo,
        })} */}


      {/* Justificación ajusté FOB */}
      {/* {
        (isShowExitForm || isCheckFormExit) &&
        renderInputWithLabel({
          labelText: `Justificación ajusté FOB`,
          name: "adjustment_justification_fob",
          activeComment: isCheckFormExit || isCheckFormEntry,
          annotationInfo,
          PropsBox: {
            as: "textarea",
            className: "col-md-12",
            p: 0,
            m: 1,
          },
        })
      } */}


    </>
  );
};

export default ViewItemsEntryForm;
